export default ({...props}) => {
  const {
    shape,
    borderWeight,
    borderColor,
    space,
    palette,
    themeGrey,
    size,
    rem,
    unit,
  } = props.theme
  return `
    > fieldset {
      display: flex;
    } 
    div.wrapper {
    display: flex;
    .MuiFormControlLabel-root {
      display: flex;
      flex-direction: column;
      border: ${borderWeight}px solid ${borderColor.main};
      text-align: center;
      margin: ${space(0.375)}px;
      border-radius: ${shape.borderRadius}px;
      height: ${size(9.75)}px;
      min-width: ${rem(2.73)};
      cursor: pointer;
      &:first-child{
        margin-left: 0px;
      }
      &:last-child{
        margin-right: 0px;
      }
      &:hover{
        background-color: ${palette.primary.light};
      }
      .MuiRadio-root{
        display: none;
      }
      .MuiFormControlLabel-label{
        display: flex;
        flex-grow: 1;
        width: 100%;
        padding-top: ${space(1.5)}px;
      }
      [ap_atom_name="stackAtom"]{
        width: 100%;
        flex-grow: 1;
        & > * {
          padding: 0px;
        }
      }
      [ap_atom_name="svgIconAtom"]{
        
        margin-top: ${space(0.3)}px;
        justify-content: center;
        height: ${size(1.5)}px;
        display: -webkit-box;
        > svg {
          width: ${size(3)}px;
        }
      }
      &[ap_type="disabled"] {
        background-color: ${themeGrey.disabled_grey};
        border-color: ${themeGrey.disabled_grey};
        [ahd_type='calDate']{
          color: ${themeGrey.medium_emphasis_grey}
        }
      }
      &[ap_date_selected="true"] {
        background-color: ${palette.primary.main};
        [ahd_type='calDate']{
          color: ${palette.common.white};
        }
        
      }
    }
    @media screen and (max-width: 376px){ 
       & .MuiFormControlLabel-root {
       min-width:${unit(12.5)}%;
        [ahd_type='calDate']{
          font-size:${rem(0.9)};
        }
       }       
        }
   }
  `
}
